import React from 'react';

export const DocManiaLogo = ({ className = "", size = "default", showTagline = false }) => {
  const sizes = {
    small: "text-lg",
    default: "text-xl",
    large: "text-2xl",
    hero: "text-4xl sm:text-5xl"
  };

  return (
    <div className={`inline-flex flex-col ${className}`}>
      <span className={`font-black tracking-tight ${sizes[size]}`}>
        <span className="brand-blue">Doc</span>
        <span className="brand-orange">Mania</span>
      </span>
      {showTagline && (
        <span className="text-sm font-normal text-muted-foreground tracking-wide">
          Doc smarter with DocMania
        </span>
      )}
    </div>
  );
};

export const DocManiaLogoImage = ({ size = 40, className = "" }) => {
  return (
    <img 
      src="/docmania-logo.png" 
      alt="DocMania" 
      width={size} 
      height={size}
      className={`rounded-xl ${className}`}
      data-testid="docmania-logo-img"
    />
  );
};

export const DocManiaFullLogo = ({ size = "default", showTagline = false, className = "" }) => {
  const iconSizes = {
    small: 32,
    default: 40,
    large: 48,
    hero: 64,
  };
  
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <DocManiaLogoImage size={iconSizes[size]} />
      <DocManiaLogo size={size} showTagline={showTagline} />
    </div>
  );
};

